// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hF-z","twoColumnImage":"iF-z"};